import React, { useState, useCallback, useMemo } from 'react';
import { withTranslation } from 'react-i18next';

import DropdownElement from 'components/dropdown-element';
import RoadmapActions from 'components/RoadmapActions';

import IconArrowDown from 'icons/icon-arrow-down';

import './MilestonesToggle.styles.css';

const MilestonesToggle = ({ projectId, count, allExpanded, onToggle, onCollapseAll, onExpandAll, t }) => {
    const [showArchived, setShowArchived] = useState(false);

    const handleShowArchivedChange = useCallback(({ id }) => {
        setShowArchived(id === 'archived');

        onToggle({ showArchived: id === 'archived' });
    }, [setShowArchived, onToggle]);

    const dropdownItems = useMemo(() => [
        {
            id: 'active',
            text: t('Active Milestones')
        },
        {
            id: 'archived',
            text: t('Archived Milestones')
        }
    ], [t]);

    return (
        <React.Fragment>
            <div className="milestones-toggle-main">
                <DropdownElement items={dropdownItems} onItemClick={handleShowArchivedChange} xAlign="left">
                    <div className="dropdown-value">
                        { showArchived ? t('Archived Milestones') : t('Active Milestones') }
                        &nbsp;
                        <IconArrowDown />
                    </div>
                </DropdownElement>

                <RoadmapActions projectId={projectId} />
            </div>

            {
                count === 0 ? (
                    <h6>{ t('noEntries.short') }</h6>
                ) : onExpandAll ? (
                    <h6 className="underlined-text-on-hover actionable" onClick={allExpanded ? onCollapseAll : onExpandAll}>{ allExpanded ? t('common:Collapse all') :  t('common:Expand all') }</h6>
                ) : (
                    <h6>{ t('Milestones_count', { count }) }</h6>
                )
            }
        </React.Fragment>
    )
}

export default withTranslation('milestone')(MilestonesToggle);
